import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument } from '@cc-shopping/structured-content-renderer/hydration/types';
import { Box, Typography } from '@mui/material';
import { PrimaryLink } from 'src/features/product-card/ApplyNowButton';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
export enum WPHouseAdTypes {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  EntryBanner = 'entry_banner',
  Card = 'card',
}
export type WPHouseAdProps = StructuredContentDocument<{
  body: string;
  headline: string;
  type: WPHouseAdTypes;
  ctaUrl?: string;
  ctaText?: string;
}>;
export const WPHouseAd = t0 => {
  const $ = _c(29);
  const {
    props
  } = t0;
  if (props.type === WPHouseAdTypes.Horizontal) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        padding: 3,
        border: "1px solid #D8D9DA",
        display: "flex"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        display: "flex",
        gap: 2
      };
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== props.headline) {
      t3 = <Typography fontWeight={700}>{props.headline}</Typography>;
      $[2] = props.headline;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== props.body) {
      t4 = <Typography>{props.body}</Typography>;
      $[4] = props.body;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
      t5 = <Box sx={t2}>{t3}{t4}</Box>;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== props.ctaUrl) {
      t6 = props.ctaUrl && <CtaLink analytics={{}} Component={PrimaryLink} href={props.ctaUrl} parameterActions={[]} sx={{
        padding: 3
      }} skipShoppingFinishedEvent={true}>{props.ctaUrl}</CtaLink>;
      $[9] = props.ctaUrl;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
      t7 = <Box sx={t1}>{t5}{t6}</Box>;
      $[11] = t5;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  } else {
    if (props.type === WPHouseAdTypes.EntryBanner) {
      let t1;
      if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          backgroundColor: "#FFF7EA",
          padding: 4,
          border: "1px solid #D8D9DA",
          display: {
            xs: "block",
            md: "flex"
          },
          justifyContent: {
            xs: "none",
            md: "space-between"
          }
        };
        $[14] = t1;
      } else {
        t1 = $[14];
      }
      let t2;
      if ($[15] !== props.headline) {
        t2 = <Typography fontWeight={700} paddingBottom=".5rem">{props.headline}</Typography>;
        $[15] = props.headline;
        $[16] = t2;
      } else {
        t2 = $[16];
      }
      let t3;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          fontSize: ".8125rem",
          paddingBottom: {
            xs: ".5rem",
            md: 0
          }
        };
        $[17] = t3;
      } else {
        t3 = $[17];
      }
      let t4;
      if ($[18] !== props.body) {
        t4 = <Typography sx={t3}>{props.body}</Typography>;
        $[18] = props.body;
        $[19] = t4;
      } else {
        t4 = $[19];
      }
      let t5;
      if ($[20] !== t2 || $[21] !== t4) {
        t5 = <Box>{t2}{t4}</Box>;
        $[20] = t2;
        $[21] = t4;
        $[22] = t5;
      } else {
        t5 = $[22];
      }
      let t6;
      if ($[23] !== props.ctaText || $[24] !== props.ctaUrl) {
        t6 = props.ctaUrl && <CtaLink analytics={{}} Component={PrimaryLink} href={props.ctaUrl} parameterActions={[]} sx={{
          padding: "1rem",
          display: "block",
          fontSize: ".8750rem",
          height: "max-content",
          letterSpacing: ".11rem",
          lineHeight: ".9"
        }} skipShoppingFinishedEvent={true}>{props.ctaText}</CtaLink>;
        $[23] = props.ctaText;
        $[24] = props.ctaUrl;
        $[25] = t6;
      } else {
        t6 = $[25];
      }
      let t7;
      if ($[26] !== t5 || $[27] !== t6) {
        t7 = <Box sx={t1}>{t5}{t6}</Box>;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
      } else {
        t7 = $[28];
      }
      return t7;
    } else {
      if (props.type === WPHouseAdTypes.Vertical) {
        console.log("Update Horizontal House Ad when you find me in the real world!");
      } else {
        if (props.type === WPHouseAdTypes.Card) {
          console.log("Update Horizontal House Ad when you find me in the real world!");
        } else {
          console.log("New House Ad type found, add me: ", props.type);
        }
      }
    }
  }
  return null;
};